import { header, footer, hero } from 'x-client-component';

type DynamicComponentKey = 'header' | 'footer' | 'hero';

const Header = () => (header ? <div dangerouslySetInnerHTML={{ __html: header }} /> : null);
const Footer = () => (footer ? <div dangerouslySetInnerHTML={{ __html: footer }} /> : null);
const Hero = () => (hero ? <div dangerouslySetInnerHTML={{ __html: hero }} /> : null);

interface Props {
    componentKey: DynamicComponentKey;
}

export const Dynamic = ({ componentKey }: Props): React.ReactElement | null => {
    switch (componentKey) {
        case 'footer':
            return <Footer />;
        case 'header':
            return <Header />;
        case 'hero':
            return <Hero />;
        default:
            return null;
    }
};
